import React from "react";
import GaugeComponent from "react-gauge-component";

const GaugeChart = ({ width, height, minValue, maxValue, value, interval, subArcs, formatTextValue, style }: any) => {
  const CalculateTicks = () => {
    const length = (maxValue - minValue) / interval + 1;
    const arr = Array.from({ length }, (_, i) => minValue + i * interval);
    const ticksModel = arr.map(x => {
      return { value: Number(x) };
    });
    return ticksModel;
  };

  const CalculateChartValue = () => {
    let initialValue = value;

    if (value > maxValue) initialValue = maxValue;
    else if (value < minValue) initialValue = minValue;

    return initialValue;
  };

  return (
    <div
      style={
        style === undefined || style === null
          ? { width: width, height: height + 100, border: "1px solid black" }
          : style
      }
    >
      <GaugeComponent
        type="radial"
        minValue={minValue}
        maxValue={maxValue}
        labels={{
          valueLabel: {
            formatTextValue: value => `${value}${formatTextValue}`,
          },
          tickLabels: {
            type: "outer",
            ticks: CalculateTicks(),
            defaultTickValueConfig: {
              formatTextValue: value => `${value}${formatTextValue}`,
              style: { fontSize: "12px", fill: "black", textShadow: "none" },
            },
          },
        }}
        arc={{
          padding: 0.02,
          width: 0.15,
          subArcs: subArcs,
        }}
        value={CalculateChartValue()}
      />
    </div>
  );
};

export default GaugeChart;

GaugeChart.defaultProps = {
  width: 500,
  height: 300,
  minValue: 0,
  maxValue: 100,
  interval: 20,
  value: 0,
  formatTextValue: "%",
};
